module.exports = __webpack_public_path__ + "static/img/4.cdc0786.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/4.png
// module id = RLOq
// module chunks = 0